import './generic_rule.js.coffee'

class Monitoring.Models.TicketRule extends Monitoring.Models.GenericRule
  urlRoot: '/monitoring/ticket_rules'

  defaults: ->
    name: ''
    description: ''
    active: true
    start_date: undefined
    end_date: null
    priority: 5
    social_content_condition: @socialContentConditionsDefaults()
    ticket_condition: @ticketConditionsDefaults()
    actions: @actionsDefaults()

  actionsDefaults: ->
    assign_ticket_to_users_group_action: ''
    assign_ticket_to_operator_action: ''
    unassign_operator_in_ticket_action: false
    unassign_user_group_in_ticket_action: false
    close_ticket_action: ''
    prioritize_ticket_action: ''
    reply_predefined_template_id: ''
    reply_channel: ''

  ticketConditionsDefaults: ->
    tags: []
    groups: []
    previous_ticket_status: []
    present_ticket_status: []
    new_ticket: ''
    prioritized_ticket: ''
    assigned_to_user_group: ''
    assigned_to_operator: ''
    operator_id: ''
    intelligent_filter: @_emptyIntelligentFilter()


class Monitoring.Collections.TicketRulesCollection extends Backbone.Collection
  model: Monitoring.Models.TicketRule
  comparator: (rule)->
    "#{rule.get('priority')}_#{rule.get('name').toLowerCase()}"
